import SearchConditionInterface from "./_SearchConditionInterface";
import SearchConditionOptions from "./_SearchConditionOptions";

const Search = () => {

  const searchConditionInterface = new SearchConditionInterface();
  const searchConditionOptions = new SearchConditionOptions();

  //リセットボタン
  const resetBtn = document.querySelector('.search__condition-btn--reset');
  if (resetBtn) {
    resetBtn.addEventListener('click', (e) => {
      searchConditionInterface.reset();
      searchConditionOptions.reset();
    });
  }
}

export default Search;